import { render } from "./Payment.m.vue?vue&type=template&id=55e35fe0"
import script from "./Payment.m.vue?vue&type=script&lang=js"
export * from "./Payment.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__